module.exports = __webpack_public_path__ + "static/logo-f7019dafa7f43a0f712fa4a44d6593a6.png";